var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.leaflet)?_c('div',{staticClass:"leaftlet-viewer-wrapper-container"},[_c('Leaflet',{attrs:{"leafletByProps":_vm.leaflet}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }